import { render, staticRenderFns } from "./NoRealTaskPage.vue?vue&type=template&id=6e55ef14&"
import script from "./NoRealTaskPage.vue?vue&type=script&lang=js&"
export * from "./NoRealTaskPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports